import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {Component} from '@angular/core';

@Component({
    templateUrl: './anfahrt-page.component.html',
    styleUrls: ['./anfahrt-page.component.scss'],
    imports: [MatCardModule, MatButtonModule]
})
export class AnfahrtPageComponent {
    showMap = false;
}
